import { Component, signal, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    @if (showBanner()) {
      <div class="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 md:p-8 pb-28 sm:pb-28 md:pb-28 lg:pb-8 pointer-events-none">
        <div class="max-w-6xl mx-auto">
          <div class="bg-[#1C1C1C] border border-[#FFFFFF10] shadow-2xl rounded-2xl p-6 pointer-events-auto flex flex-col md:flex-row gap-6 items-center justify-between">
            <div class="flex-1">
              <h3 class="text-white font-bold text-lg mb-2">Respect de votre vie privée</h3>
              <p class="text-[#FFFFFF80] text-sm">
                Nous utilisons des cookies et traceurs pour assurer le bon fonctionnement du site, personnaliser votre expérience et analyser notre trafic.
                En cliquant sur « Tout accepter », vous consentez à l'utilisation de ces cookies. 
                Vous pouvez consulter notre <a routerLink="/cookies" class="text-[#FF5620] hover:underline">Politique relative aux cookies</a> pour plus de détails.
              </p>
            </div>
            
            <div class="flex flex-col sm:flex-row gap-3 min-w-fit">
              <button 
                (click)="declineAll()"
                class="px-5 py-2.5 rounded-full border border-[#FFFFFF20] text-white hover:bg-[#FFFFFF05] transition-colors text-sm font-medium whitespace-nowrap">
                Continuer sans accepter
              </button>
              <button 
                (click)="acceptAll()"
                class="px-5 py-2.5 rounded-full bg-[#FF5620] text-white hover:bg-[#FF7043] transition-colors shadow-lg text-sm font-medium whitespace-nowrap">
                Tout accepter
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  `
})
export class CookieConsentComponent implements OnInit {
  showBanner = signal(false);

  ngOnInit() {
    const consent = localStorage.getItem('colorfol_cookie_consent');
    if (!consent) {
      // Show the banner if user hasn't made a choice yet
      setTimeout(() => this.showBanner.set(true), 500); // Slight delay for better UX
    }
  }

  acceptAll() {
    localStorage.setItem('colorfol_cookie_consent', 'accepted');
    this.showBanner.set(false);
  }

  declineAll() {
    localStorage.setItem('colorfol_cookie_consent', 'declined');
    this.showBanner.set(false);
  }
}
